// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// components
import { FormAddReconciliationItem } from '../../forms/FormAddReconciliationItem/FormAddReconciliationItem';

export interface DialogAddReconciliationItemProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

export const DialogAddReconciliationItem = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogAddReconciliationItemProps) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState<boolean>(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('addReconciliationItem'),
					loading: isLoading,
					form: 'form-add-reconciliation-item',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={600}
			onClose={onClose}
			title={{
				children: t('addReconciliationItem'),
				variant: 'h3',
			}}>
			<FormAddReconciliationItem
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
